/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * NavbarService layer between component and Content provider service to handle all filtering
 * and data manipulation logic for global navigation data
 */
import { Injectable } from '@angular/core';
import { TileManagementService } from '@support/shared/services/tile-management.service';

@Injectable()
export class WorkflowCartSupportService {
  constructor(private tileManagementService: TileManagementService) {}

  /**
   * getUniqueWorkflowForAllLines method is used to fetch unique workflows
   * @param cartResponse of type string, having flow name of repdash
   * @returns Set of string having unique workflows
   */
  public getAllTiles(): string[] {
    return this.tileManagementService.getAllTileId();
  }
}
